export default "__VITE_ASSET___V4$HhPa__";